import React from 'react';
import Testmonies from '../Testmonies/Testmonies';
import './TestmonySection.css';

const testimonialsData = [
  {
    id: 1,
    text: "Balancing school and helping my mom sell veggies in Mwanza was tough. With recorded lessons, I study at night. Now I'm top of my class in History!",
    name: "Grace L.",
    title: "Form III Student",
    location: "Mwanza",
    image: require('../../Assets/student-grace.jpg'),
    rating: 5
  },
  {
    id: 2,
    text: "The platform's 24/7 library helped me catch up after missing school for months. Now I tutor my classmates in Geography!",
    name: "David P.",
    title: "Form IV Student",
    location: "Tanga",
    image: require('../../Assets/student-david.jpg'),
    rating: 4
  },
  {
    id: 3,
    text: "I used to walk 10km to school in Dodoma. Now, I study Physics and Chemistry online with expert teachers. My Form IV results jumped from a D to a B+!",
    name: "Jamila M.",
    title: "Form IV Student",
    location: "Dodoma",
    image: require('../../Assets/student-jamila.jpg'),
    rating: 5
  },
];

function TestmonySection() {
  return (
    <section className="testimonial-section" aria-labelledby="testimonial-heading">
      <div className="testimonial-container">
        <h2 id="testimonial-heading" className="testimonial-heading">
          Success Stories from Tanzanian Students
        </h2>
        <p className="testimonial-subheading">
          See how our platform is transforming education across Tanzania
        </p>
        
        <div className="testimonial-grid">
          {testimonialsData.map((testimonial) => (
            <Testmonies 
              key={testimonial.id} 
              text={testimonial.text} 
              name={testimonial.name} 
              title={`${testimonial.title} | ${testimonial.location}`}
              image={testimonial.image}
              rating={testimonial.rating}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestmonySection;